import { useSearchParams } from "react-router-dom";
import AddLookup from "../../../Components/InputComponents/AddLookup";

function AddDepartment() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/DepartmentLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Add Department"
      alert="Department Added Successfully"
      addDataAPIEndpoint="/Department/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Department",
              name: "DL_Name",
              required: true, // Validation rule added here
              maxLength: 255,
            },
            {
              type: "select",
              label: "Status",
              name: "DL_Status",
              required: true, // Validation rule added here
              options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        DL_Name: {
          required: true,
        },
        DL_Status: {
          required: true,
        },
      }}
    />
  );
}

export default AddDepartment;
